"use client";

import { useMountEffect } from "@opensea/ui-kit/hooks";
export function useSetScrollbarSize() {
  useMountEffect(_temp);
}
function _temp() {
  const rootElement = document.body;
  if (!rootElement) {
    return;
  }
  const scrollbarSize = getScrollbarWidth();
  document.body.style.setProperty("--root-scroll-bar-size", `${scrollbarSize}px`);
}
function getScrollbarWidth() {
  const outer = document.createElement("div");
  const inner = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll";
  outer.style.width = "100px";
  outer.style.height = "100px";
  inner.style.width = "100%";
  inner.style.height = "100%";
  document.body.appendChild(outer);
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  document.body.removeChild(outer);
  return scrollbarWidth;
}